import React, { Component } from "react";
import {
  Row,
  Col,
  Box,
  Form,
  CampoTexto,
  Botao,
  TipoBotao,
  TamanhoBotao,
  TipoAlerta,
  Alerta,
} from "@intechprev/componentes-web";

import { FuncionarioService, UsuarioService } from "../../services";

import { Session } from "@intech/react-service";
// import { BaseService } from '@intech/react-service';

import { PesquisaDados, LoginEntidade } from "../../entidades";
import { reCAPTCHA } from "../../helpers";
import ReCAPTCHA from "react-google-recaptcha";
import config from "./../../config.json";

interface Props {
  history?: any;
}

interface State {
  matricula: string;
  nome: string;
  resultadoPesquisa: any;
  ReCAPTCHATokenV2: string;
  mostrarReCAPTCHA: boolean;
  erro: string;
}

export class ListarParticipantes extends Component<Props, State> {
  private recaptcha_listar = new reCAPTCHA("listar_participantes");
  private recaptcha_selecionar = new reCAPTCHA("selecionar_participantes");

  private form = React.createRef<Form>();

  constructor(props: Props) {
    super(props);

    this.state = {
      matricula: null,
      nome: null,
      resultadoPesquisa: [],
      ReCAPTCHATokenV2: "",
      mostrarReCAPTCHA: false,
      erro: ""
    };
  }

  componentDidMount = async () => {
    if (!config.admin) {
      this.props.history.push("/");
    }
  };

  pesquisar = async () => {
    try {
      let pd = new PesquisaDados();
      pd.CD_FUNDACAO = null;
      pd.CD_EMPRESA = null;
      pd.CD_PLANO = null;
      pd.CD_SIT_PLANO = null;
      pd.NUM_MATRICULA = this.state.matricula;
      pd.NOME = this.state.nome;
      pd.ReCAPTCHATokenV2 = this.state.ReCAPTCHATokenV2;
      pd.ReCAPTCHATokenV3 = await this.recaptcha_listar.getToken();
      const resultadoPesquisa = await FuncionarioService.Pesquisar(pd);
      await this.setState({
        resultadoPesquisa,
        mostrarReCAPTCHA: false,
        ReCAPTCHATokenV2: "",
        erro: ""
      });
    } catch (erro) {
      const mostrarReCAPTCHA = erro.message.indexOf("401") > -1;
      this.setState({
        erro: erro.response ? erro.response.data : erro,
        mostrarReCAPTCHA,
        ReCAPTCHATokenV2: ""
      });
    }
  };

  // selecionar = async (cpf: string, cdPlano: string) => {
  selecionar = async (cpf: string, inscricao: string) => {
    try {
      let loginInfo = new LoginEntidade();
      loginInfo.Cpf = cpf;
      loginInfo.Inscricao = inscricao;
      loginInfo.ReCAPTCHATokenV2 = this.state.ReCAPTCHATokenV2;
      loginInfo.ReCAPTCHATokenV3 = await this.recaptcha_selecionar.getToken();
      loginInfo.Origem = 1;

      const login = await UsuarioService.SelecionarParticipante(
        loginInfo
      );

      await Session.setToken(login.AccessToken, false);

      // var dados = await FuncionarioService.Buscar();

      this.props.history.push("/");
    } catch (erro) {
      const mostrarReCAPTCHA = erro.message.indexOf("401") > -1;
      this.setState({
        erro: erro.response ? erro.response.data : erro,
        mostrarReCAPTCHA
      });
    }
  };

  render() {
    return (
      <Row className={"mt-5 ml-5 mr-5"}>
        {config.admin &&
          <Col>
            <Box titulo={"Listagem de Participantes"}>
              <Form ref={this.form}>
                <CampoTexto
                  contexto={this}
                  nome={"matricula"}
                  placeholder={"Matricula"}
                  valor={this.state.matricula}
                />
                <CampoTexto
                  contexto={this}
                  nome={"nome"}
                  placeholder={"Nome"}
                  valor={this.state.nome}
                />
                <Botao
                  titulo={"Procurar"}
                  tipo={TipoBotao.primary}
                  submit
                  onClick={this.pesquisar}
                />
                {this.state.mostrarReCAPTCHA &&
                  <ReCAPTCHA
                    sitekey={config.reCAPTCHA_site_key_v2}
                    onChange={(value: any) => this.setState({ ReCAPTCHATokenV2: value })}
                  />
                }
                <Alerta tipo={TipoAlerta.danger} mensagem={this.state.erro} />
              </Form>

              {this.state.resultadoPesquisa.length > 0 && (
                <div>
                  <br />

                  <table className={"table table-hover"}>
                    <thead>
                      <tr>
                        <th style={{ width: "1px" }}></th>
                        <th>Nome</th>
                        <th>Matrícula</th>
                        <th>CPF</th>
                        <th>Empresa</th>
                        <th>Plano</th>
                        <th></th>
                      </tr>
                    </thead>

                    <tbody>
                      {this.state.resultadoPesquisa.map(
                        (func: any, index: number) => {
                          return (
                            <tr key={index}>
                              <td>
                                {func.PENSIONISTA ===
                                  "S" && (
                                    <div
                                      className={
                                        "badge badge-success"
                                      }
                                    >
                                      PENSIONISTA
                                    </div>
                                  )}
                              </td>
                              <td>
                                {func.NOME_ENTID}
                              </td>
                              <td>
                                {func.NUM_MATRICULA}
                              </td>
                              <td>{func.CPF_CGC}</td>
                              <td>
                                {func.CD_EMPRESA}
                              </td>
                              <td>{func.CD_PLANO}</td>
                              <td>
                                <Botao
                                  titulo={
                                    "Selecionar"
                                  }
                                  tipo={
                                    TipoBotao.primary
                                  }
                                  tamanho={
                                    TamanhoBotao.pequeno
                                  }
                                  onClick={async () =>
                                    await this.selecionar(
                                      func.CPF_CGC,
                                      func.NUM_INSCRICAO
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          );
                        }
                      )}
                    </tbody>
                  </table>
                </div>
              )}

              {this.state.resultadoPesquisa.length < 0 && (
                <div className={"alert alert-danger"}>
                  A pesquisa não retornou resultados
                </div>
              )}
            </Box>
          </Col>
        }
      </Row>
    );
  }
}

// export const a = "";